// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"0f5cb80e","513":"ed4d2dcf","703":"c6bc5599"}[chunkId] + ".chunk.js";
};